import { ArrowDown, ArrowUp } from "../keys";
import { listen } from "./events";

export function keyUpDown(
  node: Node,
  options: { up: (e: KeyboardEvent) => void; down: (e: KeyboardEvent) => void },
) {
  return keydown(node, (e) => {
    if (e.key == ArrowUp) options.up(e);
    if (e.key == ArrowDown) options.down(e);
  });
}

export function keydown(node: Node, fn: (e: KeyboardEvent) => void) {
  return listen(node, {
    type: "keydown",
    handler: (e: KeyboardEvent) => {
      fn(e);
    },
  });
}

export function escape(node: Node, fn: (e: KeyboardEvent) => void) {
  return listen(node.ownerDocument, {
    type: "keydown",
    handler: (e: KeyboardEvent) => {
      if (e.key == "Escape") fn(e);
    },
  });
}
